// extracted by mini-css-extract-plugin
export default {"button":"buttonStyles_button__E7l11"};